module.exports = __webpack_public_path__ + "static/media/powerbiLogo.49988e6c.svg";